//import priorityNav from 'priority-nav';
import { throttle } from 'lodash';

export function localNav() {
	const localNavSwitch = () => {
		const localNavSmall = document.querySelector( 'div.spirit-container--local-navbar' );
		const localNavLarge = document.querySelector( 'nav.spirit-container--local-navbar' );

		if ( !localNavSmall || !localNavLarge ) {
			return;
		}

		const priorityMoreHover = () => {
			const trigger = document.querySelector( '.priority-nav__wrapper' );

			if ( !trigger ) {
				return;
			}

			// Open Priority Nav on Hover
			const toggleClick = ( e ) => {
				const target = e.target;

				if ( e.target === trigger ) {
					const button = target.querySelector( '.priority-nav__dropdown-toggle' );
					button.click();
				}
			};

			trigger.addEventListener( 'mouseenter', toggleClick, true );
			trigger.addEventListener( 'mouseleave', toggleClick, true );
		};

		const createPriorityNav = () => {
			const localNavButton = document.querySelector( '.jdrf-local-navbar-item__link--parent' );
			if ( localNavButton ) {
				const priorityNavActive = document.querySelector( '.priority-nav' );

				if ( priorityNavActive ) {
					return;
				}

				/*priorityNav.init( {
					mainNavWrapper: '.jdrf-local-navbar-item--parent',
					mainNav: 'ul.jdrf-local-navbar__children',
					navDropdownClassName: 'jdrf-local-navbar__dropdown',
					navDropdownToggleClassName: 'jdrf-local-navbar__dropdown-toggle',
					navDropdownBreakpointLabel: localNavButton.textContent,
					breakPoint: 767,
					throttleDelay: 10,
					offsetPixels: 100,
				} );*/

				priorityMoreHover();
			}
		};

		/**
		 * initializeLocalNavLarge
		 * This is taken from Spirit Vertical Navigation: https://github.com/JDRF/spirit/blob/develop/library/components/vertical_navigation/vertical_navigation.js
		 *
		 * @param {object} nav
		 *
		 * @returns {void}
		 */
		const initializeLocalNavLarge = ( nav ) => {
			const parentItems = Array.from( nav.querySelectorAll( '.jdrf-local-navbar-item--parent-nested' ) );

			const menuSubOpen = ( closedItem ) => {

				closedItem.classList.add( 'submenu-is-open' );
				closedItem.parentNode.classList.add( 'child-has-focus' );
				closedItem.setAttribute( 'aria-expanded', true );

				if ( closedItem.parentNode.querySelector( '.spirit-vertical-nav__subnav' ) ) {
					closedItem.parentNode.querySelector( '.spirit-vertical-nav__subnav' ).setAttribute( 'aria-hidden', 'false' );
				}

			};

			/**
			 * Close Sub Menu(s)
			 *
			 * @param {object} openItem Open Subnav Item
			 */
			const menuSubClose = ( openItem ) => {

				openItem.classList.remove( 'submenu-is-open' );
				openItem.parentNode.classList.remove( 'child-has-focus' );
				openItem.setAttribute( 'aria-expanded', false );

				if ( openItem.parentNode.querySelector( '.sub-menu' ) ) {
					openItem.parentNode.querySelector( '.sub-menu' ).setAttribute( 'aria-hidden', 'true' );
				}

			};

			/**
			 * Sub Menu action - call open or close function
			 *
			 * @param {obg} el
			 * @param {string} type
			 *
			 * @return {void}
			 */
			const listerSubmenuAction = ( el, type ) => {
				if ( el.getAttribute( 'aria-haspopup' ) && 'enter' === type ) {
					menuSubOpen( el );
				} else if ( el.getAttribute( 'aria-haspopup' ) && 'leave' === type ) {
					menuSubClose( el );
				}
			};

			/**
			 * Listener Action for Submenu Mouse Enter
			 * @param {object} e event
			 */
			const listnerSubmenuEnter = ( e ) => {
				const target = e.currentTarget.querySelector( 'a' );

				listerSubmenuAction( target, 'enter' );

			};

			/**
			 * Listener Action for Submenu Mouse Leave
			 * @param {object} e event
			 */
			const listnerSubmenuLeave = ( e ) => {
				const target = e.currentTarget.querySelector( 'a' );

				listerSubmenuAction( target, 'leave' );

			};

			/**
			 * Loop through parent items
			 */
			parentItems.forEach( p => {
				const trigger = p.querySelector( 'a' );
				const subNav = p.querySelector( '.jdrf-local-navbar__children' );

				if ( !trigger || !subNav ) {
					return;
				}

				// Let a screen reader know this menu has a submenu by hooking into the first link
				trigger.setAttribute( 'aria-haspopup', 'true' );
				if ( !trigger.hasAttribute( 'aria-expanded' ) ) {
					trigger.setAttribute( 'aria-expanded', 'false' );
				}

				// Hide and label each sub menu
				subNav.setAttribute( 'aria-haspopup', 'true' );
				subNav.setAttribute( 'aria-label', 'Submenu' );

				p.addEventListener( 'mouseenter', listnerSubmenuEnter );
				p.addEventListener( 'mouseleave', listnerSubmenuLeave );
			} );
		};

		if ( window.matchMedia( '(min-width: 768px)' ).matches ) {
			createPriorityNav();

			localNavSmall.setAttribute( 'aria-hidden', 'true' );
			localNavSmall.style.display = 'none';

			localNavLarge.setAttribute( 'aria-hidden', 'false' );
			localNavLarge.style.display = 'block';
			initializeLocalNavLarge( localNavLarge );

		} else {
			localNavLarge.setAttribute( 'aria-hidden', 'true' );
			localNavLarge.style.display = 'none';

			localNavSmall.setAttribute( 'aria-hidden', 'false' );
			localNavSmall.style.display = 'block';
		}
	};

	window.addEventListener( 'resize', throttle( localNavSwitch, 200 ) );

	localNavSwitch();
}
